export const FETCH_FOLLOWUP_PROCESSOS = "processosInflamatorios.fetch_perguntas_followup_processos";
export const FETCH_FOLLOWUP_PROCESSOS_START = "processosInflamatorios.fetch_perguntas_followup_processos_start";
export const FETCH_FOLLOWUP_PROCESSOS_END = "processosInflamatorios.fetch_perguntas_followup_processos_end";

export const SAVE_FOLLOWUP_PROCESSOS_START = "processosInflamatorios.save_perguntas_followup_processos_start";
export const SAVE_FOLLOWUP_PROCESSOS_END = "processosInflamatorios.save_perguntas_followup_processos_end";